module.exports = __webpack_public_path__ + "static/about_placeholder-9cc892d2490e4b9b1ef15ba29a142a8f.png";